const Asterisk02Icon = /*#__PURE__*/ [
  ["path", { d: "M12.0001 4V20M19 8L5.00025 16M18.9997 16L5 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { Asterisk02Icon as default };
//# sourceMappingURL=Asterisk02Icon.js.map
